import React, { Fragment } from "react";
import { Route, Redirect } from "react-router-dom";

import GroupManagementIndex from "pages/GroupManagement/index";
import GroupManagementShow from "pages/GroupManagement/show";
import GroupManagementStore from "pages/GroupManagement/store";
import GroupManagementChannel from "pages/GroupManagement/channel";

import AccountSettingsIndex from "pages/AccountsSettings/index";
import UpdateBilling from "pages/GroupManagement/UpdateBilling";
import UpdatePlan from "pages/GroupManagement/UpdatePlan";
import UpdateFamilyDetails from "pages/GroupManagement/UpdateFamilyDetails";
import ChangePassword from "pages/AccountsSettings/ChangePassword";
import UpdateGroup from "pages/GroupManagement/UpdateGroup";

const EntityRoutes: React.FC = () => {
  return (
    <Fragment>
      {/* Manage Families | Start */}
      <Route exact path="/">
        <Redirect to="/manage-families" />
      </Route>
      <Route exact path="/manage-families" component={GroupManagementIndex} />
      <Route
        exact
        path="/manage-families/:id/details"
        component={GroupManagementShow}
      />
      <Route
        exact
        path="/manage-families/:id/edit"
        component={GroupManagementShow}
      />
      <Route
        exact
        path="/manage-families/:id/channel/:id"
        component={GroupManagementChannel}
      />
      <Route
        exact
        path="/manage-families/:id/update-billing"
        component={UpdateBilling}
      />
      <Route
        exact
        path="/manage-families/:id/update-plan"
        component={UpdatePlan}
      />
      <Route
        exact
        path="/manage-families/:id/update-families"
        component={UpdateFamilyDetails}
      />
      <Route
        exact
        path="/manage-families/:id/edit-group"
        component={UpdateGroup}
      />
      <Route exact path="/add-new-family" component={GroupManagementStore} />
      {/* Manage Families | End */}

      {/* Account Settings | Start */}
      <Route exact path="/account-settings" component={AccountSettingsIndex} />
      <Route
        exact
        path="/account-settings/:id/change-password"
        component={ChangePassword}
      />
      {/* Account Settings | Start */}
    </Fragment>
  );
};

export default EntityRoutes;
